exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".theme--light.v-footer.bot-footer[data-v-278c512f] {\n  background-repeat: repeat;\n  background-image: url(\"/public/images/templates/footer-bg-black.jpg\");\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/stylus-loader!./node_modules/vue-loader/lib??vue-loader-options!./src/components/footer/footer.vue?vue&type=style&index=0&id=278c512f&lang=stylus&scoped=true&
// module id = 113
// module chunks = 16